export const object_extends = Object.assign || function (target) {
  for (let i = 1; i < arguments.length; i++) {
    const source = arguments[i];
    for (let key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

export function date_format(date, format) {
  if (typeof date === 'string') {
    const parsedDate = new Date(date);

    if (parsedDate.toString() !== 'Invalid Date') {
      date = parsedDate;
    } else {
      format = date;
      date = new Date();
    }
  }

  if (!format) {
    format = 'yyyy-MM-dd hh:mm';
  }

  const map = {
    "M": date.getMonth() + 1, //月份
    "d": date.getDate(), //日
    "h": date.getHours(), //小时
    "m": date.getMinutes(), //分
    "s": date.getSeconds(), //秒
    "q": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
    let v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v;
        v = v.substr(v.length - 2);
      }
      return v;
    } else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length);
    }
    return all;
  });
  return format;
}

export function isNull(s) {
  if (!s) return true;
  s = s.replace(/&nbsp;/ig, ""); //去掉&nbsp;
  const patrn = /^\s*$/;
  if (!patrn.exec(s)) return false;
  return true;
}

export function isMobile(mobile) {
  if (isNull(mobile))
    return false;
  const mobileReg = !!mobile.match(/^(0|86|17951)?(13[0-9]|15[012356789]|17[03678]|18[0-9]|14[57])[0-9]{8}$/);
  return mobileReg;
}

export function buttonHelper(btn, disabledText) {
  const buttonIsInput = btn.tagName === 'INPUT';
  const originalBtnText = buttonIsInput ? btn.value : btn.innerHTML;

  return {
    disable: function () {
      btn.setAttribute('disabled', 'disabled');
      if (buttonIsInput) {
        btn.value = disabledText || '正在执行操作，请耐心等待...';
      } else {
        btn.innerHTML = disabledText || '正在执行操作，请耐心等待...';
      }
    },
    enable: function () {
      btn.removeAttribute('disabled');
      if (buttonIsInput) {
        btn.value = originalBtnText;
      } else {
        btn.innerHTML = originalBtnText;
      }
    },
    setText: function (text) {
      if (buttonIsInput) {
        btn.value = text;
      } else {
        btn.innerHTML = text;
      }
    },
    isDisabled: function () {
      return btn.getAttribute('disabled') !== null;
    }
  }
}

export function getQueryString(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export function uuidv4() {
  if ('crypto' in window && window.crypto.getRandomValues) {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  } else {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/helper.js